import type {
  HovCellGainUpgradeIndex,
  HovGainUpgradeMpTarget,
} from "@/features/hoverIdle/types";

export type { HovGainUpgradeMpTarget };

export type HovGainUpgradeMpTargetKey =
  | "global"
  | `cell:${HovCellGainUpgradeIndex}`;

const HOV_GAIN_UPGRADE_CELL_INDICES: readonly HovCellGainUpgradeIndex[] = [
  1, 2, 3, 4, 5, 6, 7, 8, 9,
];
const HOV_GAIN_UPGRADE_CELL_INDEX_SET = new Set<number>(
  HOV_GAIN_UPGRADE_CELL_INDICES,
);

export function createHovGainUpgradeMpTargetFromSlotIndex(
  slotIndex: number,
): HovGainUpgradeMpTarget | null {
  if (slotIndex === 0) {
    return "global";
  }
  if (!isHovGainUpgradeCellIndex(slotIndex)) {
    return null;
  }
  return { kind: "cell", index: slotIndex };
}

export function toHovGainUpgradeMpTargetKey(
  target: HovGainUpgradeMpTarget,
): HovGainUpgradeMpTargetKey | null {
  if (target === "global") {
    return "global";
  }
  if (target.kind !== "cell" || !isHovGainUpgradeCellIndex(target.index)) {
    return null;
  }
  return `cell:${target.index}`;
}

export function fromHovGainUpgradeMpTargetKey(
  key: HovGainUpgradeMpTargetKey,
): HovGainUpgradeMpTarget {
  if (key === "global") {
    return "global";
  }
  const index = Number(key.slice("cell:".length));
  if (!isHovGainUpgradeCellIndex(index)) {
    throw new Error(`invalid Hov Gain Upgrade MP target key: ${key}`);
  }
  return { kind: "cell", index };
}

export function isHovGainUpgradeCellIndex(
  value: number,
): value is HovCellGainUpgradeIndex {
  return Number.isInteger(value) && HOV_GAIN_UPGRADE_CELL_INDEX_SET.has(value);
}

export function countHovGainUpgradeMpTargets(
  targets: readonly HovGainUpgradeMpTarget[],
): number {
  return new Set(
    targets
      .map((target) => toHovGainUpgradeMpTargetKey(target))
      .filter((key): key is HovGainUpgradeMpTargetKey => key !== null),
  ).size;
}
